/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React, { useEffect, useState } from 'react';
import {
    Button,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from 'reactstrap';

const SaveFavouriteModal = ({
    container,
    saveAs,
    isOpen,
    onCancel,
    onSave
}: {
    container: string;
    saveAs: any;
    isOpen: boolean;
    onCancel: Function;
    onSave: Function;
}) => {
    const [label, setLabel] = useState<string>(saveAs);
    useEffect(() => {
        setLabel(saveAs);
    }, [saveAs]);
    const cancel = () => {
        if (onCancel !== undefined) onCancel();
    };
    const save = () => {
        if (onSave !== undefined) onSave(label);
    };
    return (
        <Modal isOpen={isOpen} toggle={cancel} container={container}>
            <ModalHeader toggle={cancel}>Save...</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="label">
                            Type a name into the box below, then click{' '}
                            <b>Save</b> to store for future use.
                        </Label>
                        <Input
                            type="text"
                            name="label"
                            id="label"
                            placeholder="Type your name here"
                            value={label}
                            onChange={(evt: any) => setLabel(evt.target.value)}
                        />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={save}>
                    Save
                </Button>
                <Button color="secondary" onClick={cancel}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default SaveFavouriteModal;
